import styled from 'styled-components';
import { Drawer } from '@material-ui/core';
import LinkMenu from 'components/LinkMenu';
import { NavLink as NavLinkDefault } from 'react-router-dom';
import { Subtitle } from 'components/Typography';
import DefaultButton from 'components/Buttons/Button';
import DefaultLogo from 'components/Logo';
import History from 'assets/icons/history.svg?react';
import Orders from 'assets/icons/orders.svg?react';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  min-width: 20rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
`;

// TODO: TFR-44 move to container group
export const Section = styled.div``;

export const Menu = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  position: sticky;
  top: 0;
  padding: 1.75rem 1rem 1.5rem 1rem;
`;

// TODO: TFR-44 move to container group
export const DrawerContainer = styled(Drawer)`
  border-radius: 0rem 1rem 1rem 0rem;
  box-shadow: 0rem 0.5rem 2rem 0rem rgba(0, 0, 0, 0.1);

  .MuiDrawer-paper {
    width: 20rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    padding: 1.75rem 1rem 1.5rem 1rem;
  }
`;

// TODO: TFR-45:Heading make unique name or do not export
export const Heading = styled.div`
  display: flex;
  align-items: center;
  padding: 0rem 1rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const LogoContainer = styled(NavLinkDefault)``;

// TODO: TFR-45:Logo make unique name or do not export
export const Logo = styled(DefaultLogo)`
  height: auto;
  width: 8.6831rem;
`;

// TODO: TFR-44 move to container group
export const LinksContainer = styled.div`
  margin-top: 1.75rem;
  display: flex;
  flex-direction: column;
`;

// TODO: TFR-44 move to icon group
export const FiHistory = styled(History)`
  width: 1.5rem;
  height: 1.5rem;
`;

// TODO: TFR-44 move to icon group
export const FiOrders = styled(Orders)`
  width: 1.5rem;
  height: 1.5rem;
`;

// TODO: TFR-45:Link make unique name or do not export
export const Link = styled(LinkMenu)`
  :not(:last-child) {
    margin-bottom: 0.7rem;
  }
  span {
    color: ${({ theme }) => theme.colors.iconGray};
  }
  &.selected {
    span {
      color: ${({ theme }) => theme.colors.greenDark};
    }
  }
`;

// TODO: TFR-44 move to typography group
export const LinkText = styled(Subtitle)`
  color: ${({ theme }) => theme.colors.navyGreen};
`;

// TODO: TFR-44 move to container group
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  display: flex;
  align-items: center;
  justify-content: left;
  font-weight: normal;
  font-size: 1.3125rem;
  padding: 0 1.25rem;
  height: 4rem;
`;

// TODO: TFR-45 make unique name or do not export
export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  margin-right: 1rem;
  font-size: 1.5rem;
`;

// TODO: TFR-44 move to button group
export const LogoutButton = styled(Button)`
  background: none;
  margin-top: 0.7rem;
  ${IconContainer} {
    color: ${({ theme }) => theme.colors.iconGray};
  }
  :hover {
    background: ${({ theme }) => theme.colors.navyGreenLight} !important;
  }
  :active {
    background: ${({ theme }) => theme.colors.navyGreenLight} !important;
    font-weight: 600;
    ${IconContainer} {
      color: ${({ theme }) => theme.colors.greenDark};
    }
  }
`;
